/* eslint-disable import/no-cycle */
import BudgetService from '@/services/api/budget';
import BudgetServiceService from '@/services/api/budgetService';
import BudgetLogs from '@/services/api/budgetLogs';
import BudgetProductService from '@/services/api/budgetProduct';

const getDefaultState = () => ({
  isLoading: false,
  hasMoreData: false,
  selectedBudget: null
});

const state = getDefaultState();

const getters = {
  isLoading(state) {
    return state.isLoading;
  },
  hasMoreData(state) {
    return state.hasMoreData;
  },
  getSelectedBudget(state) {
    return state.selectedBudget;
  }
};

const mutations = {
  SET_LOADING(state, status) {
    state.isLoading = status;
  },
  SET_HAS_MORE_DATA(state, status) {
    state.hasMoreData = status;
  },
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
  SET_SELECTED_BUDGET(state, payload) {
    if (payload === null) {
      state.selectedBudget = null;
      return;
    }

    const discount = payload.discount ? parseFloat(payload.discount, 0) : null;

    if (payload.service_order && payload.service_order.service_order_photos) {
      const order = ['entry_medias_main', 'entry_medias_front', 'entry_medias_rear', 'entry_medias_right', 'entry_medias_left', 'entry_medias_panel'];
      payload.service_order.service_order_photos.sort((a, b) => order.indexOf(a.tag) - order.indexOf(b.tag));
    }

    const selectedBudget = {
      ...payload,
      discount
    };

    state.selectedBudget = selectedBudget;
  },
  UPDATE_RESPONSIBLE(state, payload) {
    state.selectedBudget.responsible = payload;
    state.selectedBudget.responsible_id = payload?.id || null;
    state.selectedBudget.responsible_name = payload?.name || null;
  },
  UPDATE_STATUS(state, payload) {
    state.selectedBudget.status = payload;
  },
  UPDATE_VISIBLE_CLIENT(state, payload) {
    state.selectedBudget.visible_client = payload;
  },
  ADD_LOG(state, payload) {
    const { description, createdAt, user } = payload;

    const log = {
      description,
      created_at: createdAt,
      user: {
        name: user.name
      }
    };

    // eslint-disable-next-line no-unused-expressions
    state.selectedBudget.budget_logs?.push(log);

    BudgetLogs.create({
      description,
      user_id: user.id,
      budget_id: state.selectedBudget.id
    });
  },
  PUSH_BUDGET_SERVICES(state, servicesCreated) {
    state.selectedBudget.budget_services.push(...servicesCreated);
  },
  PUSH_BUDGET_PRODUCTS(state, productsCreated) {
    state.selectedBudget.budget_products.push(...productsCreated);
  },
  UPDATE_SELECTED_DATE(state, payload) {
    state.selectedBudget.date = payload;

    const onlyDate = payload.split('T')[0];

    const currentHour = new Date().getHours();
    const currentMinutes = new Date().getMinutes();
    const currentSeconds = new Date().getSeconds();
    const date = new Date(
      `${onlyDate}T${currentHour.toString().padStart(2, '0')}:${currentMinutes.toString().padStart(2, '0')}:${currentSeconds
        .toString()
        .padStart(2, '0')}`
    );

    BudgetService.update(state.selectedBudget.id, {
      date
    });
  },
  UPDATE_CLIENT(state, payload) {
    state.selectedBudget.client = payload;

    BudgetService.update(state.selectedBudget.id, {
      client_id: payload.id
    });
  },
  UPDATE_DISCOUNT(state, payload) {
    // Novo modo: desconto separado por serviço e produto
    if (payload.isNewMode) {
      const parseValue = (val) => {
        if (!val) return null;
        const cleanVal = val.toString().replace('.', '').replace(',', '.').trim();
        const numVal = parseFloat(cleanVal) || 0;
        return numVal > 0 ? numVal : null;
      };

      const discountServices = parseValue(payload.discount_services);
      const discountProducts = parseValue(payload.discount_products);

      state.selectedBudget.discount_services = discountServices;
      state.selectedBudget.discount_type_services = discountServices === null ? null : payload.discount_type_services;
      state.selectedBudget.discount_products = discountProducts;
      state.selectedBudget.discount_type_products = discountProducts === null ? null : payload.discount_type_products;

      BudgetService.update(state.selectedBudget.id, {
        discount_services: discountServices,
        discount_type_services: discountServices === null ? null : payload.discount_type_services,
        discount_products: discountProducts,
        discount_type_products: discountProducts === null ? null : payload.discount_type_products
      });
    } else {
      // Modo legado
      const { type, value } = payload;

      state.selectedBudget.discount = value === '0,00' ? null : parseFloat(value.replace('.', '').replace(',', '.').trim());
      state.selectedBudget.discount_type = value === '0,00' ? null : type;

      BudgetService.update(state.selectedBudget.id, {
        discount: value === '0,00' ? null : parseFloat(value.replace('.', '').replace(',', '.').trim()),
        discount_type: value === '0,00' ? null : type
      });
    }
  },
  UPDATE_ENTRY_VALUE(state, payload) {
    state.selectedBudget.entry_value = payload;
  },
  REMOVE_BUDGET_SERVICE(state, payload) {
    const index = state.selectedBudget.budget_services.findIndex((b) => b.id === payload.id);
    if (index !== -1) {
      BudgetServiceService.inactivate(state.selectedBudget.id, payload.id);

      state.selectedBudget.budget_services.splice(index, 1);
    }
  },
  REMOVE_BUDGET_PRODUCT(state, payload) {
    const index = state.selectedBudget.budget_products.findIndex((b) => b.id === payload.id);
    if (index !== -1) {
      BudgetProductService.inactivate(state.selectedBudget.id, payload.id);

      state.selectedBudget.budget_products.splice(index, 1);
    }
  },
  UPDATE_BUDGET_PRODUCT(state, payload) {
    const { product, action } = payload;

    if (action === 'decrease') {
      product.amount -= 1;
    } else if (action === 'increase') {
      product.amount += 1;
    }
    product.total_value = product.amount * product.unitary_value;

    BudgetProductService.update(state.selectedBudget.id, product.id, {
      amount: product.amount,
      total_value: product.total_value
    });
  },
  UPDATE_BUDGET_SERVICE(state, payload) {
    const { service, action } = payload;

    if (action === 'decrease') {
      service.amount -= 1;
    } else if (action === 'increase') {
      service.amount += 1;
    }

    service.total_value = service.amount * service.unitary_value;

    BudgetServiceService.update(state.selectedBudget.id, service.id, {
      amount: service.amount,
      total_value: service.total_value
    });
  },
  ALTER_BUDGET_SERVICE(state, payload) {
    const { service } = payload;

    const unitaryValue = parseFloat(service.unitary_value.replace('R$ ', '').replace('.', '').replace(',', '.').trim());
    const amount = parseInt(service.amount, 0);
    const totalValue = unitaryValue * amount;

    BudgetServiceService.update(state.selectedBudget.id, service.id, {
      amount,
      unitary_value: unitaryValue,
      total_value: totalValue
    });

    const index = state.selectedBudget.budget_services.findIndex((b) => b.id === service.id);

    state.selectedBudget.budget_services[index].amount = amount;
    state.selectedBudget.budget_services[index].unitary_value = unitaryValue.toFixed(2);
    state.selectedBudget.budget_services[index].total_value = totalValue.toFixed(2);
  },
  ALTER_BUDGET_PRODUCT(state, payload) {
    const { product } = payload;

    const unitaryValue = parseFloat(product.unitary_value.replace('R$ ', '').replace('.', '').replace(',', '.').trim());
    const amount = parseInt(product.amount, 0);
    const totalValue = unitaryValue * amount;

    BudgetProductService.update(state.selectedBudget.id, product.id, {
      amount,
      unitary_value: unitaryValue,
      total_value: totalValue
    });

    const index = state.selectedBudget.budget_products.findIndex((b) => b.id === product.id);

    state.selectedBudget.budget_products[index].amount = amount;
    state.selectedBudget.budget_products[index].unitary_value = unitaryValue.toFixed(2);
    state.selectedBudget.budget_products[index].total_value = totalValue.toFixed(2);
  },
  UPDATE_SERVICE_ORDER(state, payload) {
    let serviceOrderPhotos = [];

    if (payload.service_order && payload.service_order.service_order_photos) {
      serviceOrderPhotos = payload.service_order_photos.filter((photo) => !photo.photo_url.includes('.mp4', 'service_medias_'));

      const order = ['entry_medias_main', 'entry_medias_front', 'entry_medias_rear', 'entry_medias_right', 'entry_medias_left', 'entry_medias_panel'];
      serviceOrderPhotos.sort((a, b) => order.indexOf(a.tag) - order.indexOf(b.tag));
    }

    state.selectedBudget.service_order = {
      ...payload,
      service_order_photos: serviceOrderPhotos
    };

    state.selectedBudget.client = payload.client;

    BudgetService.update(state.selectedBudget.id, {
      service_order_id: payload.id,
      client_id: payload.client.id
    });
  },
  UPDATE_OBSERVATION(state, payload) {
    state.selectedBudget.observation = payload;

    BudgetService.update(state.selectedBudget.id, {
      observation: payload
    });
  },
  MANAGE_PAYMENT_CONDITIONS(state, payload) {
    const { condition, action } = payload;

    state.selectedBudget.budget_payment_conditions = state.selectedBudget.budget_payment_conditions || [];

    if (action === 'ADD_PAYMENT_CONDITION') {
      const index = state.selectedBudget.budget_payment_conditions.findIndex((b) => b.payment_condition_id === condition.payment_condition_id);
      if (index === -1) {
        state.selectedBudget.budget_payment_conditions.push(condition);
      } else {
        state.selectedBudget.budget_payment_conditions[index].description = condition.description;
      }
    } else if (action === 'REMOVE_PAYMENT_CONDITION') {
      const index = state.selectedBudget.budget_payment_conditions.findIndex((b) => b.payment_condition_id === condition.payment_condition_id);
      if (index !== -1) {
        state.selectedBudget.budget_payment_conditions.splice(index, 1);
      }
    }
  },
  MANAGE_PAYMENT_METHODS(state, payload) {
    const { method, action } = payload;

    state.selectedBudget.budget_payment_methods = state.selectedBudget.budget_payment_methods || [];

    if (action === 'ADD_PAYMENT_METHOD') {
      const index = state.selectedBudget.budget_payment_methods.findIndex((b) => b.payment_method_id === method.payment_method_id);
      if (index === -1) {
        state.selectedBudget.budget_payment_methods.push(method);
      } else {
        state.selectedBudget.budget_payment_methods[index].description = method.description;
      }
    } else if (action === 'REMOVE_PAYMENT_METHOD') {
      const index = state.selectedBudget.budget_payment_methods.findIndex((b) => b.payment_method_id === method.payment_method_id);
      if (index !== -1) {
        state.selectedBudget.budget_payment_methods.splice(index, 1);
      }
    }
  },
  UPDATE_ATTACHMENT(state, payload) {
    const { attachment } = payload;

    const index = state.selectedBudget.budget_attachments.findIndex((b) => b.id === attachment.id);
    if (index !== -1) {
      state.selectedBudget.budget_attachments[index].description = attachment.description;
    }
  },
  ADD_ATTACHMENT(state, payload) {
    const { attachment } = payload;

    state.selectedBudget.budget_attachments.push(attachment);
  },
  REMOVE_ATTACHMENT(state, payload) {
    const { attachment } = payload;

    const index = state.selectedBudget.budget_attachments.findIndex((b) => b.id === attachment.id);
    if (index !== -1) {
      state.selectedBudget.budget_attachments.splice(index, 1);
    }
  }
};

const actions = {
  resetState({ commit }) {
    commit('RESET_STATE');
  },
  setLoading({ commit }, status) {
    commit('SET_LOADING', status);
  },
  setHasMoreData({ commit }, status) {
    commit('SET_HAS_MORE_DATA', status);
  },
  cleanSelectedBudget({ commit }) {
    commit('SET_SELECTED_BUDGET', null);
  },
  async addBudgetServices({ commit, state }, { services }) {
    const servicesToCreate = services.map((payload) => ({
      service_id: payload.id,
      service: payload,
      amount: 1,
      total_value: payload.value,
      unitary_value: payload.value,
      optional: !payload.service?.required
    }));

    const response = await BudgetServiceService.create({
      budget_id: state.selectedBudget.id,
      services: servicesToCreate
    });

    const servicesCreated = servicesToCreate.map((service) => {
      const created = response.data.find(({ service_id: serviceId }) => serviceId === service.service_id);
      return { ...service, id: created.id };
    });

    commit('PUSH_BUDGET_SERVICES', servicesCreated);
  },
  async addBudgetProducts({ commit, state }, { products }) {
    const productsToCreate = products.map((payload) => ({
      product_id: payload.id,
      product: payload,
      amount: 1,
      total_value: payload.value,
      unitary_value: payload.value,
      optional: !payload.product?.required
    }));

    const response = await BudgetProductService.create({
      budget_id: state.selectedBudget.id,
      products: productsToCreate
    });

    const productsCreated = productsToCreate.map((product) => {
      const created = response.data.find(({ product_id: productId }) => productId === product.product_id);
      return { ...product, id: created.id };
    });

    commit('PUSH_BUDGET_PRODUCTS', productsCreated);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
